exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-page {\n  background-color: #ffffff;\n  padding-bottom: 55px;\n}\n.error-page .error-title {\n  font-size: 11em;\n  color: #fdc600;\n}\n.error-page .error-title h2 {\n  margin: 10px 0px;\n  font-size: 11em;\n  font-weight: 300;\n  text-transform: uppercase;\n  letter-spacing: 4px;\n}\n.error-page .error-title p {\n  font-size: 24px;\n  padding: 10px 20% 25px;\n  line-height: 27px;\n  font-weight: normal;\n}\n", ""]);

// exports
